import { List } from '@mui/material';
import { useNavigate, useLocation } from 'react-router';
import MobileSidebarItem from './UIElements/MobileSidebarItem';
import SidebarLogo from './UIElements/SidebarLogo';
import { getMenuItems } from './UIElements/sidebarConfig';
import { LuPanelRightOpen } from 'react-icons/lu';
import { useSelector } from 'react-redux';
/**
 * Mobile sidebar component (LeftBar)
 * Provides mobile navigation that aligns with the main Sidebar component
 * @param {Object} props - Component props
 * @param {boolean} props.openBar - Controls sidebar open/collapsed state (unused in mobile)
 * @param {function} props.setIsSidebarOpen - Function to close the mobile sidebar
 */
const LeftBar = ({ setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleRouteChange = (route) => {
    navigate(route);
  };

  const isSelected = (route) =>
    location.pathname === route || location.pathname.startsWith(route + '/');

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
  };
  const { userDetails, userPermissions, webServices } = useSelector(
    (state) => state.auth?.successData ?? {},
  );
  const MENU_ITEMS = getMenuItems(userDetails, userPermissions, webServices);
  return (
    <div className='bg-[#1e3a8a] h-full flex flex-col'>
      <div className='h-[55px] bg-[#2A489E] flex items-center'>
        <SidebarLogo className='p-2' />
      </div>

      <List sx={{ mt: 2 }}>
        {MENU_ITEMS.map((item) => (
          <MobileSidebarItem
            key={item.id}
            route={item.route}
            label={item.label}
            icon={item.icon}
            isSelected={isSelected(item.route)}
            isSidebarOpen={false} // Mobile sidebar is always expanded when open
            onClick={handleRouteChange}
            onClose={handleCloseSidebar}
            className={item.className}
          />
        ))}
      </List>

      <div
        className='mt-auto mx-2 mb-2 h-10 bg-[#3f5eb5]  rounded text-white flex items-center justify-center'
        onClick={() => setIsSidebarOpen((prev) => !prev)}
      >
        <div className='flex'>
          <LuPanelRightOpen size='24' />
          &nbsp;&nbsp; Close
        </div>
      </div>
    </div>
  );
};

export default LeftBar;
